import audio from '@/scripts/audio';
import { random } from 'lodash';
import Enemy from '../actors/Enemy';
import state from '../state';
import ticker from '../ticker';

class Enemies {
  constructor(parent, player) {
    this.parent = parent;
    this.player = player;
    this.spawnProbability = 0.1;
    this.spawnDelay = 5000;
    this.lastTime = 0;

    this.frameHandler = () => { this.frame(); };

    this.enemies = [];
  }

  startSpawn() {
    this.lastTime = Date.now();
    ticker.add(this.frameHandler);
  }

  frame() {
    for (let i = this.enemies.length - 1; i >= 0; i -= 1) {
      const enemy = this.enemies[i];
      enemy.sprite.position.y -= ticker.speed * state.speed + 1; // Increase the enemy speed by 1

      if (enemy.sprite.position.y <= 0) {
        enemy.destroy();
        this.enemies.splice(i, 1);
      }
    }

    const delay = Date.now() - this.lastTime;
    if (delay >= this.spawnDelay) {
      this.lastTime = Date.now();
      if (random(0, 1, true) <= this.spawnProbability) {
        this.spawn();
      }
    }
  }

  spawn() {
    const enemy = new Enemy(this.parent, this.player);
    this.enemies.push(enemy);
    audio.play('enemy');
  }

  gameover() {
    ticker.remove(this.frameHandler);
    for (let i = this.enemies.length - 1; i >= 0; i -= 1) {
      const enemy = this.enemies[i];
      enemy.destroy();
      this.enemies.splice(i, 1);
    }
  }
}

export default Enemies;
